import React from "react";
import { Container, Col, Row, Form, Button } from "react-bootstrap";
import Map from "../components/Map";

function Address() {

  return (
    <div>
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} lg={8} className="rgc-request p-4 rgc-profile ">
            <div className="d-flex rgc-title">
              <div className="rgc-title-point"></div>
              <h4>ثبت آدرس <span>محل سکونت</span></h4>
            </div>
            <Row className="justify-content-center g-5">
              <Col xs={12}>
                <Form.Group controlId="formBasicCode">
                  <Form.Label>آدرس کد پستی</Form.Label>
                  <Form.Control type="number"   autoComplete="off" placeholder="آدرس کد پستی" />
                </Form.Group>
              </Col>

              <Col xs={12} className="text-center" style={{zIndex:"0"}}>
                <Map />
              </Col>

              <Col xs={4} className="text-center">
                <Button className="rgc-order-btn rgc-order-btn-sub">
                  ثبت آدرس
                </Button>
              </Col>

            </Row>
          </Col>

        </Row>
      </Container>
    </div>
  );
}

export default Address;
